export default "__VITE_ASSET__CHqNiOst__"